import { features } from '@/mocks/home';

const iconColors = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-700',
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么百万漫迷选择韩漫网</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 md:p-7 text-center group hover:bg-background-50 transition-colors">
              <div className={`w-14 h-14 mx-auto rounded-xl ${iconColors[i]} flex items-center justify-center mb-5`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}